module.exports = __webpack_public_path__ + "img/earth.954efcfe.svg";